"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FieldNumber = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var react_final_form_1 = require("react-final-form");
var TextField_1 = __importDefault(require("../TextField"));
var parseNumber = function (min, max) { return function (value) {
    if (!value)
        return undefined;
    var numValue = parseInt(value.replace(/[^\d]/g, ''), 10); // Remove any text char typed in and Cast string to number ("123" => 123)
    if (Number.isNaN(numValue))
        return min;
    return Math.max(Math.min(max !== null && max !== void 0 ? max : Infinity, numValue), min !== null && min !== void 0 ? min : 0);
}; };
var FieldNumber = function (props) { return ((0, jsx_runtime_1.jsx)(react_final_form_1.Field, __assign({ color: "primary", 
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    component: TextField_1.default, parse: parseNumber(props.min, props.max) }, props, { format: function (value) { return (value === null || value === void 0 ? void 0 : value.toLocaleString()); } }))); };
exports.FieldNumber = FieldNumber;
